import React, { useEffect } from 'react';
import { NavigationContainer } from '@react-navigation/native';

import { createNativeStackNavigator } from '@react-navigation/native-stack';

import Auth from '../auth';
import Tabs from './tabs';
import TabsVendedor from './tabsVendedor';
import SorteioDetalhe from '../pages/sorteioDetalhe';
import SorteioManuntencao from '../pages/sorteioManuntencao';

import Cidades from '../pages/cidades';
import CriarCidade from '../pages/cidades/criar';

import Vendedores from '../pages/vendedores';
import CriarVendedor from '../pages/vendedores/criar';

import Gerentes from '../pages/gerentes';
import CriarGerente from '../pages/gerentes/criar';

import VincularVendedor from '../pages/vendedores/vincularVendedor';
import CartelasVendedor from '../pages/vendedores/cartelasVendedor';
import VenderCartela from '../pages/vendedores/cartelaVender';
import Sortear from '../pages/sortear';

import Clientes from '../pages/clientes';
import ClientesCartela from '../pages/clientesCartela';
import Relatorio from '../pages/relatorio';
import CartelaClienteID from '../pages/clientesCartelaID';

const Stack = createNativeStackNavigator();

const Routes = () => {
  return (
    <NavigationContainer>
      <Stack.Navigator>
        <Stack.Screen
          options={{ headerShown: false, title: 'Login' }}
          name="Auth"
          component={Auth}
        />
        <Stack.Screen
          options={{ headerShown: false, title: 'Big Sorte' }}
          name="Tabs"
          component={Tabs}
        />
        <Stack.Screen
          options={{ headerShown: false, title: 'Big Sorte' }}
          name="TabsVendedor"
          component={TabsVendedor}
        />
        <Stack.Screen
          options={{ title: 'Detalhe Sorteio' }}
          name="SorteioDetalhe"
          component={SorteioDetalhe}
        />
        <Stack.Screen
          options={{ title: 'Manuntenção' }}
          name="SorteioManuntencao"
          component={SorteioManuntencao}
        />
        <Stack.Screen
          options={{ title: 'Vincular vendedores' }}
          name="vendedorVincular"
          component={VincularVendedor}
        />
        <Stack.Screen
          options={{ title: 'Cartelas do Vendedor' }}
          name="cartelasVendedor"
          component={CartelasVendedor}
        />
        <Stack.Screen
          options={{ title: 'Vender cartela' }}
          name="VenderCartela"
          component={VenderCartela}
        />

        <Stack.Screen
          options={{ title: 'Cidades' }}
          name="Cidades"
          component={Cidades}
        />
        <Stack.Screen
          options={{ title: 'Cadastro de cidade' }}
          name="CidadeCadastro"
          component={CriarCidade}
        />

        <Stack.Screen
          options={{ title: 'Vendedores' }}
          name="Vendedores"
          component={Vendedores}
        />
        <Stack.Screen
          options={{ title: 'Cadastro de vendedor' }}
          name="VendedorCadastro"
          component={CriarVendedor}
        />

        <Stack.Screen
          options={{ title: 'Gerentes' }}
          name="Gerentes"
          component={Gerentes}
        />
        <Stack.Screen
          options={{ title: 'Cadastro de gerente' }}
          name="GerenteCadastro"
          component={CriarGerente}
        />

        <Stack.Screen
          options={{ title: 'Sortear' }}
          name="Sortear"
          component={Sortear}
        />
        <Stack.Screen
          options={{ title: 'Relatório' }}
          name="Relatorio"
          component={Relatorio}
        />
        <Stack.Screen
          options={{ title: 'Clientes' }}
          name="Clientes"
          component={Clientes}
        />
        <Stack.Screen
          options={{ title: 'Clientes' }}
          name="ClientesCartelas"
          component={ClientesCartela}
        />
        <Stack.Screen
          options={{ headerShown: false, title: 'Clientes' }}
          name="ClientesCartelasID"
          component={CartelaClienteID}
        />
      </Stack.Navigator>
    </NavigationContainer>
  );
};

export default Routes;
